//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import * as Utils from "eai-configurator-ui/components/Utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import ErrorMessageDialog, {useErrorMessageDialog,} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";
import UploadIcon from "@material-ui/icons/Publish";

const UploadMultipleFileSingleSubmitWithConfigurationButton = ({
                                                                 url,
                                                                 icon,
                                                                 label,
                                                                 handleSuccess,
                                                                 selectedFiles,
                                                                 submitEmptyRequest,
                                                                 ...props
                                                               }) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [errorMessage, setErrorMessage] = useErrorMessageDialog();

  const handleSubmit = async () => {
    const configurationValues = Config.buildConfigurationValueDtos();

    // upload and submit files
    if (selectedFiles.length === 0 && submitEmptyRequest) {
      const data = new FormData();
      data.append("values", JSON.stringify({values: configurationValues}));
      await submitData(data);
    } else if (selectedFiles.length > 0) {
      selectedFiles.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
      await uploadFiles(selectedFiles, configurationValues);
    }
  };

  const uploadFiles = async (files, configurationValues) => {
    if (!submitted) {
      console.log("Submitting fileS [" + files + "] to URL [" + url + "]");
      setSubmitted(true);
      const data = new FormData();
      for (const file of files) {
        data.append("file", file);
      }
      data.append("values", JSON.stringify({values: configurationValues}));

      //
      await submitData(data);
    }
  };

  const submitData = async (data) => {
    await Utils.fetchData(
      url,
      {
        method: "POST",
        body: data,
      },
      false
    )
      .then((success) => {
        setSubmitted(false);
        if (handleSuccess) {
          handleSuccess();
        }
      })
      .catch((response) => {
        Utils.getErrorMessage(response, "Request failed.").then(
          setErrorMessage
        );
      });
  }

  return (
    <span>
      <ErrorMessageDialog {...errorMessage} />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={submitted}
        icon={<UploadIcon/>}
        startIcon={
          submitted ? <CircularProgress color="inherit" size={20}/> : icon
        }
        {...props}
      >
        {label}
      </Button>
    </span>
  );
};
export default UploadMultipleFileSingleSubmitWithConfigurationButton;
